// import ImageOne from 'C:/Users/com/Desktop/homepage/homepage/src/images/쉐어플러그_01.svg';
import ImageTwo from '../../../images/쉐어플러그_02.svg';
// import ImageThree from 'C:/Users/com/Desktop/homepage/homepage/src/images/쉐어플러그_03.svg';

import Icon1 from '../../../images/icon1.png';
import Icon2 from '../../../images/icon2.png';
import Icon3 from '../../../images/icon3.png';



export const ProblemSectionData = {
	id: 'about',
	lightBg: false,
	lightText: true,
	lightTextDesc: true,
	topLine: '쉐어플러그는 설치 비용이 저렴하고 운영 비용도 낮아, 현재 빠르게 사용 지역을 넓혀가고 있습니다.',
	Icon1: Icon1,
  bolddes: '쉽게 콘센트를 사용할 수 있습니다.',
	buttonLabel: 'Get started',
	imgStart: false,
	alt: 'car',
	dark: true,
	primary: true,
	darkText: false,

  topLine2: '개별 충전기를 콘센트에 꼽아 충전하는 모든 모빌리티의 충전 방식은 쉐어플러그로 충전이 가능합니다.',
	Icon2: Icon2,
  bolddes2: '도전으로 의심받는 문제를 해결합니다.',

  topLine3: '콘센트 주위에서 충전을 할 수 있는 구조로 주차 및 충전에서 오는 스트레스와 다양한 문제를 해결합니다.',
	Icon3: Icon3,
  bolddes3: '다양한 전기 충전 문제를 해결합니다.',

};


export const ContentSectionData = {
	id: 'about',
	lightBg: false,
	lightText: true,
	lightTextDesc: true,
	topLine: '전기 도둑 급증에 "차단 솔루션" 봇물',
	headLine: '언론',
	imgStart: false,
	alt: 'car',
	dark: true,
	primary: true,
	darkText: false,
  img2:ImageTwo,

  topLine2: '[CES 2021 ALL DIGITAL] 레인써클, 전기 공유콘센트 "쉐어 플러그" 소개',
	headLine2: 'icon2',

  topLine3: '[로그人] 정재웅 레인써클 대표 "잠금형 전기차 콘센트, 실증특례 발판삼아 …',
	headLine3: 'icon3',

};
